// The pattern builder's invalid-condition treatment (Condition.tsx,
// PatternListItem.tsx) — the same border red and soft glow, so an invalid
// step/output reads identically to an invalid condition.
export const INVALID_BORDER_COLOR = 'rgb(201,80,80)'
export const INVALID_GLOW = '0px 0px 10px rgb(196 127 127)'
export const INVALID_TRANSITION = 'border-color 0.2s ease, box-shadow 0.2s ease'
